<template>
  <b-modal
    :id="modalId"
    hide-footer
    hide-header
    centered
    size="lg"
    @shown="search(1)"
  >
    <div class="modal-title-row">
      <h6>Selecionar {{ title }}</h6>
      <button class="close-button" @click="$bvModal.hide(modalId)">
        <b-icon-x scale="1.3" />
      </button>
    </div>

    <div class="search-row">
      <b-input
        v-model="query"
        size="sm"
        :placeholder="`Pesquisar ${title.toLowerCase()} por nome`"
        @keyup.enter="search(1)"
      />
      <b-button class="search-button" size="sm" @click="search(1)">
        <b-icon-search />
      </b-button>
    </div>

    <div class="table-responsive">
      <table class="selection-table">
        <thead>
          <tr>
            <th>Nome</th>
            <th>CPF/CNPJ</th>
            <th class="action-column">Selecionar</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td>{{ itemName(item) }}</td>
            <td>{{ item.cpfCnpj || "--" }}</td>
            <td class="action-column">
              <b-button size="sm" class="select-button" @click="select(item)">
                Selecionar
              </b-button>
            </td>
          </tr>
          <tr v-if="!loading && !items.length">
            <td colspan="3" class="empty-row">Nenhum registro encontrado.</td>
          </tr>
          <tr v-if="loading">
            <td colspan="3" class="empty-row">
              <b-spinner small /> Carregando...
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination-row">
      <button :disabled="page === 1" @click="previousPage">
        <b-icon-chevron-left />
      </button>
      <span>{{ page }}</span>
      <button :disabled="items.length < 9" @click="nextPage">
        <b-icon-chevron-right />
      </button>
    </div>
  </b-modal>
</template>

<script>
import api from "../../services/axios";

export default {
  props: {
    modalId: { type: String, required: true },
    partyType: { type: String, required: true },
  },
  data() {
    return {
      query: "",
      items: [],
      page: 1,
      loading: false,
    };
  },
  computed: {
    title() {
      return this.partyType === "Cliente" ? "Cliente" : "Fornecedor";
    },
  },
  methods: {
    itemName(item) {
      return item.nome || item.nomeFantasia || item.razaoSocial || "--";
    },
    async search(page = 1) {
      this.page = page;
      this.loading = true;
      try {
        const endpoint =
          this.partyType === "Cliente" ? "/customers" : "/providers";
        const type = this.partyType === "Cliente" ? "nome" : "nome";
        const { data } = await api.get(endpoint, {
          params: {
            q: this.query,
            type,
            page: this.page,
            filterType: "includes",
            ...(this.partyType === "Fornecedor" ? { status: "ativo" } : {}),
          },
        });
        this.items = data.data || [];
      } catch (error) {
        this.items = [];
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Não foi possível carregar os registros",
          type: "info",
        });
      } finally {
        this.loading = false;
      }
    },
    select(item) {
      this.$emit("selected", { id: item.id, name: this.itemName(item) });
      this.$bvModal.hide(this.modalId);
    },
    previousPage() {
      if (this.page > 1) this.search(this.page - 1);
    },
    nextPage() {
      if (this.items.length === 9) this.search(this.page + 1);
    },
  },
  watch: {
    partyType() {
      this.query = "";
      this.items = [];
      this.page = 1;
    },
  },
};
</script>

<style scoped>
.modal-title-row,
.search-row,
.pagination-row {
  display: flex;
  align-items: center;
}
.modal-title-row {
  justify-content: space-between;
  color: #3a4750;
  margin-bottom: 18px;
}
.modal-title-row h6 {
  margin: 0;
  font-weight: 600;
}
.close-button {
  border: 0;
  background: transparent;
  color: #666360;
}
.search-row {
  margin-bottom: 16px;
}
.search-row .form-control {
  border-radius: 5px 0 0 5px;
}
.search-button,
.select-button {
  background: #006256;
  border-color: #006256;
}
.search-button {
  border-radius: 0 5px 5px 0;
}
.selection-table {
  width: 100%;
  font-size: 12px;
  color: #3a4750;
}
.selection-table th {
  background: #f1eeee;
  padding: 10px;
}
.selection-table td {
  border-bottom: 1px solid #eceaea;
  padding: 9px 10px;
}
.action-column {
  width: 110px;
  text-align: center;
}
.empty-row {
  text-align: center;
  padding: 25px !important;
}
.pagination-row {
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}
.pagination-row button,
.pagination-row span {
  width: 30px;
  height: 30px;
  border: 1px solid #d5d3d3;
  border-radius: 50%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pagination-row button:disabled {
  opacity: 0.35;
}
</style>
